module.exports = __webpack_public_path__ + "static/img/icon-map.24ef015d.svg";